import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

type UseSearchableTabsOptions = {
  tabKey?: string
  resetPageKey?: string | null
  defaultValue?: string
}

export const useSearchableTabs = (options: UseSearchableTabsOptions = {}) => {
  const { tabKey = 'tab', resetPageKey = 'page', defaultValue } = options
  const [searchParams, setSearchParams] = useSearchParams()

  const activeTab = searchParams.get(tabKey) || defaultValue || ''

  const setActiveTab = useCallback(
    (value: string, customTabKey?: string) => {
      setSearchParams(prevParams => {
        const params = new URLSearchParams(prevParams)
        params.set(customTabKey || tabKey, value)
        if (resetPageKey) {
          params.set(resetPageKey, '1')
        }
        return params
      })
    },
    [resetPageKey, setSearchParams, tabKey]
  )

  return {
    activeTab,
    searchParams,
    setActiveTab,
    setSearchParams
  }
}
